exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uk-grid > *[data-v-f9a4209c]{\n    padding-left: 2vw;\n}\n.list-box[data-v-f9a4209c]{\n    border: thin solid #707070;\n}\n.list-box-item[data-v-f9a4209c]{\n    padding: 5px;\n    position: relative;\n}\n.list-box-item i[data-v-f9a4209c]{\n    position: absolute;\n    right: 5px;\n    top: 8px;\n}\n", ""]);

// exports
